const LABELS = {
  DECLARATION: 'Declaration',
  CONFIRMATION_MESSGE:
    'By Submitting this referral you confirm you accept the term and conditions as state above',
};

export default LABELS;
